import React from "react";

export const TermsTextEs = (props) => {
  return (
    <div id="terms" className="text-center">
      <div className="containerInfo">
        <div className="section-title">
          <article className="arti">
            <h1 className="headerInfo">Términos del servicio de ColorYou</h1>
            <p>
              Al descargar o utilizar la aplicación aceptas estos Términos.
              Léelos con atención antes de usar la app. En iOS, el uso también
              se rige por el Apple Standard EULA disponible en{" "}
              <a
                href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.apple.com/legal/internet-services/itunes/dev/stdeula/
              </a>
              . En Android, el uso se rige por las{" "}
              <a
                href="https://play.google.com/intl/ALL_es/about/play-terms/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Condiciones de Servicio de Google Play
              </a>
              , incluyendo sus políticas de compras y reembolsos aplicables{" "}
              <a
                href="https://support.google.com/googleplay/answer/2479637?hl=es-419"
                target="_blank"
                rel="noopener noreferrer"
              >
                (política de reembolsos)
              </a>
              . Estos Términos complementan dichos acuerdos.
            </p>

            <span className="sep"></span>
            <br />

            <h1 className="headerInfo2">1. Licencia y propiedad intelectual</h1>
            <p>
              Te concedemos una licencia personal, no exclusiva, intransferible
              y revocable para usar la app conforme a estos Términos y a la
              legislación aplicable. No puedes copiar ni modificar la app o
              cualquier parte de ella, eliminar o alterar marcas, intentar
              extraer su código fuente, descompilar, realizar ingeniería
              inversa, traducirla ni crear obras derivadas. La app y todos los
              derechos de propiedad intelectual asociados pertenecen a ColorYou
              o sus licenciantes.
            </p>

            <h1 className="headerInfo2">
              2. Cambios en la app y posibles cargos
            </h1>
            <p>
              Trabajamos para que la app sea útil y eficiente. Podemos realizar
              cambios en la app o cobrar por ciertos servicios en cualquier
              momento. Nunca te cobraremos sin indicarte claramente el concepto
              y el precio en la hoja de compra de la tienda correspondiente.
            </p>

            <h1 className="headerInfo2">3. Compras dentro de la app</h1>
            <p>La app ofrece dos opciones de acceso de pago:</p>
            <ul>
              <li>
                a) Acceso Premium 7 días sin renovación automática que
                desbloquea todas las funciones premium.
              </li>
              <li>
                b) Acceso Premium Completo que desbloquea todas las funciones
                premium de forma ilimitada. Pago único sin renovación
                automática.
              </li>
            </ul>
            <p>
              El precio se muestra en la hoja de compra y puede variar según el
              país. Las compras se procesan a través de Apple o Google. ColorYou
              no accede a tus datos de pago. Los reembolsos se gestionan según
              las políticas de Apple o Google. Las compras están vinculadas a tu
              Apple ID o cuenta de Google Play y pueden restaurarse con la misma
              cuenta con la opción "Restaurar Compras". No ofrecemos
              suscripciones auto-renovables. El acceso a contenidos de pago está
              sujeto a la disponibilidad de la app y del servicio. Los impuestos
              y la facturación son determinados por Apple o Google según tu país
              de residencia. Cualquier incidencia con el cargo debe tramitarse
              con la tienda correspondiente.
            </p>

            <h1 className="headerInfo2">4. Privacidad y datos</h1>
            <p>
              La app puede almacenar en tu dispositivo (solo en tu dispositivo)
              datos personales que proporcionas para prestar el servicio.
              Consulta la Política de privacidad para conocer qué datos
              tratamos, con qué fines y tus derechos:{" "}
              <a
                href="https://coloryou.app/#/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://coloryou.app/#/privacy
              </a>
              .
            </p>

            <h1 className="headerInfo2">5. Permisos del dispositivo</h1>
            <p>
              La app solicita acceso a recursos protegidos como la cámara y la
              fototeca para funciones descritas en la app, por ejemplo realizar
              un selfie para el análisis de color o fotografiar tejidos o
              estampados. Si decides no otorgar permisos, algunas
              funcionalidades pueden no estar disponibles.
            </p>

            <h1 className="headerInfo2">6. Seguridad del dispositivo</h1>
            <p>
              Es tu responsabilidad mantener seguro tu teléfono y el acceso a la
              app. No recomendamos hacer jailbreak o root al dispositivo, ya que
              podría exponerlo a software malicioso, comprometer su seguridad y
              afectar al funcionamiento de la app.
            </p>

            <h1 className="headerInfo2">
              7. Conectividad y costes del operador
            </h1>
            <p>
              Algunas funciones requieren conexión a Internet. ColorYou no es
              responsable si la app no funciona plenamente por falta de conexión
              o por límites de datos. Si usas la app sin Wi-Fi, pueden aplicarse
              cargos de datos o itinerancia por parte de tu operador. Al usar la
              app aceptas la responsabilidad de dichos cargos.
            </p>

            <h1 className="headerInfo2">
              8. Disponibilidad, actualizaciones y compatibilidad
            </h1>
            <p>
              La app está disponible para iOS y Android. Los requisitos pueden
              cambiar y podrías necesitar instalar actualizaciones para seguir
              usándola. No garantizamos que la app se mantenga siempre
              actualizada o compatible con todas las versiones del sistema
              operativo. Podemos dejar de ofrecer la app o terminar su uso en
              cualquier momento. Al finalizar el servicio, los derechos de uso
              concedidos cesarán y deberás dejar de usar la app y, en su caso,
              desinstalarla.
            </p>

            <h1 className="headerInfo2">9. Limitación de responsabilidad</h1>
            <p>
              Aunque procuramos mantener la app actualizada y precisa,
              dependemos de información de terceros. En la medida permitida por
              la ley, ColorYou no se hace responsable de pérdidas directas o
              indirectas derivadas del uso de la app, de interrupciones del
              servicio, de cambios en la disponibilidad o de decisiones tomadas
              en base a la información proporcionada por la app.
            </p>

            <h1 className="headerInfo2">10. Servicios de terceros</h1>
            <p>
              La app puede integrar servicios de terceros cuyas condiciones y
              políticas se aplican adicionalmente, entre otros:
            </p>
            <ul>
              <li>
                <a
                  href="https://www.revenuecat.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  RevenueCat
                </a>
              </li>
            </ul>

            <h1 className="headerInfo2">11. Terminación</h1>
            <p>
              Podemos suspender o terminar tu acceso a la app si incumples estos
              Términos o por razones operativas. Salvo indicación en contrario,
              al terminar el servicio cesarán los derechos y licencias otorgados
              y deberás dejar de usar la app.
            </p>

            <h1 className="headerInfo2">12. Cambios en estos Términos</h1>
            <p>
              Podemos actualizar estos Términos. Publicaremos la versión vigente
              y su fecha de efecto en esta página. El uso continuado de la app
              tras los cambios implica la aceptación de los nuevos Términos.
            </p>

            <h1 className="headerInfo2">13. Contacto</h1>
            <p>
              Si tienes preguntas o sugerencias sobre estos Términos, escríbenos
              a <span style={{ color: "#DD3D99" }}>coloryouapp@gmail.com</span>.
            </p>

            <span className="sep"></span>
            <br />

            <p>Fecha de efecto: 2025-09-08</p>
          </article>
        </div>
      </div>
    </div>
  );
};
